import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class BeamTypeReferenceService extends BaseReferenceService {
  constructor() {
    super('BeamTypeReference');
  }
}
